import React from 'react';
import './Button.css';

import { Link } from 'react-router-dom';

const Button = (props) => {
  const { title, link, icon: Icon } = props;  // Destructure the 'icon' prop and rename it to 'Icon'

  // Determine button classes
  const btnClass = `btn${Icon ? ' btn-2' : ''}`;

  return (
    <Link to={`/${link}`} className={btnClass}>
      {title}
      {Icon && <div className='icon'><Icon /></div>}  {/* Dynamically render the icon */}
    </Link>
  );
};

export default Button;